<template lang="pug">
.bg-page
  .container
    section
      .title-decoration
        .dot
        .dot
        .dot
        .dot
      h1 {{ $route.meta.title }}
      p.text-center
        | 如果活動有開通全家 FamiPort 代碼繳費方式，您可以用此方式到全臺灣的全家便利商店進行代碼繳費。
        br
        | （請注意：單筆訂單總金額不足 TWD$1,500 或超過 TWD$30,000 皆無法選用全家 FamiPort 代碼繳費方式）
    .mb-10
    section
      .section-title 注意事項
      .paragraph-wrap
        .em-title
          .icon-logo
          .text
            | 請務必在繳費期限前持代碼前往全家 FamiPort 機台列印繳費單，並且完成付款。逾期訂單會被系統自動取消。
            br
            | 繳費完成後的一個工作天內，可於 4Gamers 會員認證的信箱或登入 WirForce 官網，收到劃位通知。
      .section-title 1. 選擇「繳費」
      .help-content
        img(src="~assets/payment/help01.png")
        img(src="~assets/payment/next.png")
      .section-title 2. 選擇「代碼繳費」
      .help-content
        img(src="~assets/payment/help02.png")
        img(src="~assets/payment/next.png")
      .section-title 3. 同意條款
      .help-content
        img(src="~assets/payment/help03.png")
        img(src="~assets/payment/next.png")
      .section-title 4. 輸入「繳費代碼」
      .help-content
        img(src="~assets/payment/help04.png")
        img(src="~assets/payment/next.png")
      .section-title 5. 確認繳費代碼
      .help-content
        img(src="~assets/payment/help05.png")
        img(src="~assets/payment/next.png")
      .section-title 6. 列印繳費單
      .help-content
        img(src="~assets/payment/help06.png")
        img(src="~assets/payment/next.png")
      .mb-40
</template>

<script>
import { mapGetters } from 'vuex'
// import _ from 'lodash'

export default {
  name: 'payment',
  beforeRouteEnter (to, from, next) {
    next(vm => {
    })
  },
  beforeRouteLeave (to, from, next) {
    next(vm => {
    })
  },
  props: {
    fullScreenCount: {
      type: Object
    },
    isMobile: {
      type: Boolean
    },
    mobileMenuSwitch: {
      type: [Boolean, Function]
    },
    isPortrait: {
      type: Boolean
    }
  },
  data () {
    return {
      nowTab: -1,
      tabs: [
        {
          name: 'WF限定周邊'
        },
        {
          name: '4Gamers Shop'
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
    ])
  },
  methods: {
  },
  mounted () {
    // Place images after loaded
    this.$Lazyload.$on('loaded', () => {
      console.log('Loaded')
    })
  },
  watch: {
  },
  beforeDestroy () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '~stylesheets/variables'
@import '~stylesheets/components'
@import '~stylesheets/mixin'
.paragraph-wrap
  img
    display: block
.help-content
  img
    max-width: 100%
</style>



// WEBPACK FOOTER //
// payment.vue?5165c1e8